import {connect, store} from "src/store";
import React from "react";
import PropsProxy from "../layout/PropsProxy";
import TextInput from "../form/TextInput";
import {ifCompletedInput} from "../../utils/other";

export const convertFrom = ({value, unit}: {value: number, unit: string}) => {
    if (!value) return value;
    // @ts-ignore
    const units = store.getState().app.context.units;
    const from_unit = unit.toLowerCase();
    if (units?.[from_unit]?.['base']) {
        const base_unit = units[from_unit]['base'];
        const to_unit = base_unit.toLowerCase();
        if (units?.[from_unit]?.['base'] === units?.[to_unit]?.['base']) {
            return Math.round(value / units[from_unit]['conversion'] * 10000) / 10000;
        }
    }
    return value;
}

export const convertTo = ({value, unit}: {value: number, unit: string}) => {
    if (!value) return value;
    // @ts-ignore
    const units = store.getState().app.context.units;
    const from_unit = unit.toLowerCase();
    if (units?.[from_unit]?.['base']) {
        const base_unit = units[from_unit]['base'];
        const to_unit = base_unit.toLowerCase();
        if (units?.[from_unit]?.['base'] === units?.[to_unit]?.['base']) {
            return Math.round(value * units[from_unit]['conversion'] * 10000) / 10000;
        }
    }
    return value;
}

export type UnitPropsType = {
    value: number,
    unit: string,
    children?: any|(({convertFrom, convertTo}: {convertFrom: (value: number) => number, convertTo: (value: number) => number, value: number}) => any),
};

export type UnitsType = {
    [key: string]: {
        base: string, conversion: number
    }
};

const ConnectedConvertComponent = connect((state: any) => {
    return {
        units: state.app.context.units,
    }
})(({value, unit, units, children, ...rest}: UnitPropsType&{units?: UnitsType, [key: string]: any}) => {
    if (!unit) return null;
    const from_unit = unit.toLowerCase();
    let _convertTo;
    let _convertFrom;
    if (units?.[from_unit]?.['base']) {
        const base_unit = units[from_unit]['base'];
        const to_unit = base_unit.toLowerCase();
        if (units?.[from_unit]?.['base'] === units?.[to_unit]?.['base']) {
            _convertTo = (value: number) => convertTo({value, unit: from_unit});
            _convertFrom = (value: number) => convertFrom({value, unit: from_unit});
            if (value) {
                value = _convertTo(value);
                if (isNaN(value)) {
                    value = 0;
                }
            }
        }
    }
    const formatted = <span className="unit">{value ?? "0"} {from_unit}</span>;
    if (children) {
        return <PropsProxy
            value={value}
            unit={unit}
            units={units}
            convertTo={_convertTo}
            convertFrom={_convertFrom}
            formatted={formatted}
            {...rest}
        >
            {children}
        </PropsProxy>
    }
    return formatted;
});

export const UnitConvertComponent = React.forwardRef((props: UnitPropsType, ref) => {
    return <ConnectedConvertComponent ref={ref} {...props} />
});

export const DataGridUnitConvertComponent = ({value, row}: {value?: number, row?: any}) => <UnitConvertComponent value={value ?? 0} unit={row?.unit ?? 'db'} />;
export const SelectorGridUnitConvertComponent = (value?: number, row?: any) => <UnitConvertComponent value={value ?? 0} unit={row?.unit ?? 'db'} />;

export const SelectorGridUnitConvertComponentEditor = (parent: any) =>
    (props: any, value: any) => <UnitConvertComponent value={value} unit={props.rowData.unit}>
        {({value, convertFrom}: {value?: number, convertFrom: (value: number) => number}) =>
            <TextInput
                type={["db", "pcs"].indexOf(props.rowData.unit) !== -1 ? "number" : "decimal"}
                name={props.field}
                label={false}
                focus
                value={value}
                onKeyDown={(e: Event, field: string, value: any) => {
                    value = convertFrom(value);
                    ifCompletedInput(e) && parent.onEditorValueChange(props, value);
                }}
                onBlur={(e: Event, field: string, value: any) => {
                    value = convertFrom(value);
                    parent.onEditorValueChange(props, value);
                }}
            />}
    </UnitConvertComponent>